export default "__VITE_ASSET__CZcx6JEq__"